<template>
  <Card title="歡迎使用">
    <div class="meta">
      <div class="meta-row">
        <span class="meta-label">販賣機編號</span>
        <span class="meta-value">{{ posMachineCode }}</span>
      </div>
    </div>

    <ol class="steps">
      <li>按下 <b>「開始交易」</b>,啟動本次購買流程</li>
      <li>再於販賣機進行 <b>投幣購買</b></li>
      <li>回此 <b>填寫發票資訊</b></li>
    </ol>

    <p class="note">※ 啟動後若 60 秒內未操作將自動逾時,需重新開始交易。</p>

    <template #footer>
      <button class="btn btn-primary full" :disabled="starting" @click="$emit('start')">
        <Spinner v-if="starting" />
        <span v-else>開始交易</span>
      </button>
    </template>
  </Card>
</template>

<script setup lang="ts">
import Card from './Card.vue'
import Spinner from './Spinner.vue'

defineProps<{
  posMachineCode: string
  starting?: boolean
}>()

defineEmits<{ (e: 'start'): void }>()
</script>

<style scoped>
.meta {
  background: #f9fafb;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 12px;
}
.meta-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.meta-label {
  color: #6b7280;
}
.meta-value {
  color: #111827;
  font-weight: 500;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.steps {
  margin: 4px 0 12px;
  padding-left: 22px;
  color: #374151;
  font-size: 15px;
  line-height: 1.7;
}
.steps li {
  margin: 2px 0;
}
.note {
  margin: 0;
  color: #92400e;
  background: #fef3c7;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
}
.full {
  width: 100%;
}
</style>
